module.exports = __webpack_public_path__ + "static/media/gem.60513a2d.png";